<template>
  <el-dialog
    :title="$t('app.loginForm.dialogTitle')"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
  >
    <el-form
      ref="loginForm"
      :model="form"
      :rules="rules"
      label-width="80px"
      @submit.native.prevent="handleSubmit"
    >
      <el-form-item :label="$t('app.loginForm.emailLabel')" prop="email">
        <el-input
          v-model="form.email"
          :placeholder="$t('app.loginForm.emailPlaceholder')"
          type="email"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('app.loginForm.passwordLabel')" prop="password">
        <el-input
          v-model="form.password"
          :placeholder="$t('app.loginForm.passwordPlaceholder')"
          type="password"
          show-password
        ></el-input>
      </el-form-item>
      <!-- <div class="form-footer">
        <el-checkbox v-model="form.remember">{{ $t('app.loginForm.rememberMe') }}</el-checkbox>
        <el-button type="text" @click="handleForgotPassword">
          {{ $t('app.loginForm.forgotPassword') }}
        </el-button>
      </div> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('app.loginForm.cancelButton') }}</el-button>
      <el-button 
        type="primary" 
        :loading="loading"
        @click="handleSubmit"
      >
        {{ $t('app.loginForm.loginButton') }}
      </el-button>
      <div class="register-link">
        {{ $t('app.loginForm.registerPrompt') }}
        <el-button type="text" @click="handleRegister">
          {{ $t('app.loginForm.registerButton') }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'LoginForm',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      form: {
        email: '',
        password: '',
        remember: false
      },
      rules: {
        email: [
          { required: true, message: this.$t('app.loginForm.emailRequired'), trigger: 'blur' },
          { type: 'email', message: this.$t('app.loginForm.emailInvalid'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('app.loginForm.passwordRequired'), trigger: 'blur' },
          { min: 6, message: this.$t('app.loginForm.passwordMinLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            await this.$store.dispatch('login', this.form)
            this.$message({
              type: 'success',
              message: this.$t('app.loginForm.loginSuccess')
            })
            this.handleClose()
          } catch (error) {
            this.$message.error(this.$t('app.loginForm.loginFailure'))
          } finally {
            this.loading = false
          }
        }
      })
    },
    handleClose() {
      this.$refs.loginForm.resetFields()
      this.$emit('update:visible', false)
    },
    handleForgotPassword() {
      // TODO: 实现忘记密码功能
      this.$message(this.$t('app.loginForm.forgotPasswordMessage'))
    },
    handleRegister() {
      this.handleClose()
      this.$emit('show-register')
    }
  }
}
</script>

<style lang="less" scoped>
.login-form {
  .form-header {
    text-align: center;
    margin-bottom: 30px;

    h2 {
      font-size: 24px;
      color: var(--text-primary);
      margin-bottom: 10px;
    }

    p {
      color: var(--text-regular);
      font-size: 14px;
    }
  }

  .el-form {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }

  .form-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .dialog-footer {
    text-align: center;
  }

  .register-link {
    margin-top: 15px;
    text-align: center;
    font-size: 14px;
    color: var(--text-regular);

    .el-button {
      color: var(--primary-color);
      cursor: pointer;
      margin-left: 10px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style> 
